module.exports = __webpack_public_path__ + "media/cool.1b26d061.mp3";